export default __webpack_public_path__ + "static/media/jsfront.4770f6cb.svg";